export { default } from './Meteodades';
